import DashboardLayout from '../layouts/DashboardLayout'

export const tutorMenu = {
  path: '/:module',
  component: DashboardLayout,
  name: 'Tutors',
  // redirect: '/tutor',
  children: [
    {
      path: 'report/employee-report',
      name: 'Tutor Employee Report',
      component: () => import (/* webpackChunkName: "about" */'../pages/report/department-report/employee-report/EmployeeReport'),
      meta: {
        roles: ['human-resources-report_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Gia sư: Báo cáo nhân viên',
        }]
      },
    }
  ],
}
